import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Observable, map, of } from 'rxjs';
import { VirtualTourGQL } from 'src/generated/graphql';
import { completeData } from '@app/_helpers/apollo';

@Component({
    selector: 'app-virtual-tour',
    templateUrl: './virtual-tour.component.html',
    styleUrls: ['./virtual-tour.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VirtualTourComponent implements OnInit {

  constructor(private virtualTourGql: VirtualTourGQL) {}

  virtualTour$: Observable<any> = of();

  ngOnInit(): void {
    this.virtualTour$ = this.virtualTourGql.watch().valueChanges.pipe(
      completeData(),
      map(response => {
        return response.data.virtualTour
      })
    )
  }
}
